const newChartTypes = ['graphv2']

export function isLegacyChartType(chartType: string) {
    return !(newChartTypes.includes(chartType));
}